import { DateTime } from 'luxon';

/**
 * Calculates the number of weekdays between two dates, excluding weekends and overlapping holidays.
 * @param {string} date_start - The start date in ISO format.
 * @param {string} date_end - The end date in ISO format.
 * @param {Array} holidays - An array of holiday objects with a 'date' property in ISO format.
 * @returns {number} - The number of vacation days.
 * Note: This was added because I use this is multiple locations
 */
export const calculateWeekDaysForVacation = (date_start, date_end, holidays) => {
    let count = 0;
    let current = DateTime.fromISO(date_start, { zone: 'utc' });
    const end = DateTime.fromISO(date_end, { zone: 'utc' });

    // Count weekdays in the range (1=Monday, 7=Sunday)
    while (current <= end) {
        const day = current.weekday;
        if (day !== 6 && day !== 7) count++;
        current = current.plus({ days: 1 });
    }

    // Only count overlapping holidays that are weekdays
    const weekdayHolidays = holidays.filter(holiday => {
        const holidayDate = DateTime.fromISO(holiday.date, { zone: 'utc' });
        const holidayDay = holidayDate.weekday;
        return holidayDay !== 6 && holidayDay !== 7;
    });

    count -= weekdayHolidays.length;
    return count;
};


export const extractCountryCode = (location) => {
    if (!location) return null;
    const match = location.match(/\(([^)]+)\)/);
    return match ? match[1].trim() : null;
};